import DateBox from 'devextreme-react/date-box'
import Loader from 'Common/Loader';
import DataGrid, { Column, Item, Pager, Paging, SearchPanel, Toolbar, } from 'devextreme-react/cjs/data-grid';
import TextBox from 'devextreme-react/cjs/text-box';
import CustomStore from 'devextreme/data/custom_store';
import React, { useState, useEffect, useRef } from 'react'
import { Card, Pagination } from 'react-bootstrap';
import { DateRangeBox } from 'devextreme-react/cjs/date-range-box';
import { getAllReturnSalesListData } from '../return-customer-to-franchise/customerTofranchiase/services/CustomerToFranchaiase.service';
const ReturnSalesList = () => {
  const [loading] = useState(false);
  const [permissionDetails, setPermissionDetails] = useState<string[]>([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [pagination, setPagination] = useState({ pageSize: 10, pageNumber: 1 });
  const [filterDate, setFilterDate] = useState("");
  const dataGridRef = useRef<DataGrid>(null);
  const [searchText, setSearchText] = useState('');
  const now = new Date();
  const msInDay = 1000 * 60 * 60 * 24;
  const initialValue: [Date, Date] = [
    new Date(now.getTime() - msInDay * 3),
    new Date(now.getTime() + msInDay * 3),
  ];

  useEffect(() => {
    const authUserString = localStorage.getItem("authPOSUser");
    if (authUserString) {
      const authUser = JSON.parse(authUserString);
      const permissionData = authUser?.permissions || [];
      setPermissionDetails(permissionData);
    }
  }, []);

  const HasPermission = (permission: string): boolean => {
    return permissionDetails.includes(permission);
  };

  const dataSource = (): any | undefined => {
    return new CustomStore({
      key: 'id',
      load: async (loadOptions) => {
        try {
          const search = JSON.parse(JSON.stringify(loadOptions));
          let parameterList = new URLSearchParams();
          for (const [key, value] of Object.entries(search)) {
            parameterList.append(key, JSON.stringify(value));
          }

          if (searchText) {
            parameterList.append("Search", searchText);
          }
          const response = await getAllReturnSalesListData(parameterList);
          return {
            data: response.data || [],
            totalCount: response.data.totalCount || 0,
          };

        } catch (error) {
          console.error("Data loading error:", error);
          return { data: [], totalCount: 0 };
        }
      }
    })
  }
  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="page-content">
        <div className="container-fluid" style={{ overflow: "auto" }}>
          <Card>
            <Card.Header className=" d-flex justify-content-between align-items-center">
              <h5 className='m-0'>Return Sales List</h5>
            </Card.Header>
            <Card.Body>

              <DataGrid
                dataSource={dataSource()}
                remoteOperations={{ groupPaging: true }}
                showRowLines={true}
                keyExpr="id"
                key={refreshKey}
                showBorders={true}
                columnAutoWidth={true}
              >

                <Toolbar>
                  <Item location="before">
                    <div className="informer">
                      <div>
                        <DateRangeBox
                          width="255"
                          defaultValue={initialValue}
                        />
                      </div>
                    </div>
                  </Item>
                  <Item location="before" locateInMenu='auto'>
                    <div className="informer">
                      <div>
                        <div className="dx-label"><span data-mark="" style={{ transform: "translateX(-12px)" }}>Search</span></div>
                        <TextBox
                          width="255"
                          placeholder='Search...'
                          value={searchText}
                          onValueChanged={(e) => setSearchText(e.value)}
                          onChange={(e: any) => {
                            dataGridRef.current?.instance.refresh();
                          }}

                        />
                      </div>
                    </div>
                  </Item>

                </Toolbar>
                <Pager
                  visible={true}
                  showPageSizeSelector={true}
                  showNavigationButtons={true}
                  allowedPageSizes={[10, 25, 50, 100]}

                  displayMode="full"
                  showInfo={true}
                />
                <Paging pageSize={pagination?.pageSize} />


                <Column caption='Sr.No.'
                  dataType='number'
                  alignment='center'
                  width="15%"
                  cellRender={(e) => {
                    const rowIndex = e.rowIndex + 1 + e.component.pageIndex() * e.component.pageSize();
                    return <span>{rowIndex}</span>;
                  }} />
                <Column dataField='returnCode'
                  caption='Return Code'
                  dataType='string' />
                <Column dataField='invoiceNo'
                  caption='Invoice No.'
                  dataType='string' />
                <Column dataField='returnDate'
                  caption='Return Date'
                  dataType='date' />
                <Column dataField='customerName'
                  caption='Customer Name'
                  dataType='string' />
                <Column dataField='salesPerson'
                  caption='Sales Person'
                  dataType='string' />
                <Column dataField='type'
                  caption='Type'
                  dataType='string' /><Column dataField='totalAmt'
                    caption='Total Amt'
                    dataType='string' />
                {/* <Column dataField='action'
              caption='Return Code'
              dataType='string' /> */}
              </DataGrid>
            </Card.Body>

          </Card>
        </div>
      </div>
    </React.Fragment>

  )
}

export default ReturnSalesList